import { combineReducers } from '@reduxjs/toolkit';
import { gop } from './reducer';
import { NameSpace } from '../const';
import { dataMain } from '../store/data-main/data-main';
import { dataSummary } from '../store/data-summary/data-summary';
import { dataReportFactory } from '../store/report-factory/report-factory';
import { filtersMain } from '../store/filters/filters';
import { directions } from '../store/directions/directions';
import { currentDate } from '../store/date/date';
import { reports } from './reportReduser';
import { settings } from '../store/settings/settings';
import { reportKPIReducer } from '../store/report-kpi/reducer';

export const rootGop = combineReducers({
  gop,
  reports,
  reportKPI: reportKPIReducer,
  [NameSpace.DataMain]: dataMain.reducer,
  [NameSpace.DataSummary]: dataSummary.reducer,
  [NameSpace.ReportFactory]: dataReportFactory.reducer,
  [NameSpace.FiltersMain]: filtersMain.reducer,
  [NameSpace.Directions]: directions.reducer,
  [NameSpace.Date]: currentDate.reducer,
  [NameSpace.Settings]: settings.reducer,
});
